const glideInstances = {};

const setActiveSwatch = (e) => {
  const productId = e.getAttribute("data-swatch-product-id");
  const currentProductSwatches = Array.from(
    document.querySelectorAll(`.color-swatch-${productId}`)
  );
  currentProductSwatches.map((swatch) =>
    swatch.parentElement.classList.remove("color_swatch-active")
  );
  e.parentElement.classList.add("color_swatch-active");
};

const onProductCardSwatchClick = (e) => {
  const productSizes = JSON.parse(e.getAttribute("data-swatch-product-sizes"));
  const productId = e.getAttribute("data-swatch-product-id");
  const relatedProductId = e.getAttribute("data-swatch-related-product-id");
  const productColor = e.getAttribute("data-swatch-product-color");
  const productImagesSource = JSON.parse(
    e.getAttribute("data-swatch-product-image")
  );
  const productUrl = e.getAttribute("data-swatch-product-url");
  const productTitle = e.getAttribute("data-swatch-product-title");

  const productColorLabel = document.querySelectorAll(
    `.color-swatch_label-${productId}`
  );
  const productImages = document.querySelectorAll(
    `.product-image-${productId}`
  );
  const productSizeChart = document.querySelector(
    `.size-variants_wrapper-${productId}`
  );
  const productAnchors = Array.from(
    document.querySelectorAll(`.product_card_link-${productId}`)
  );
  const productImagesContainer = document.querySelector(
    `.product_card_slides-${productId}`
  );
  const bulletContainer = document.querySelector(
    `.bullet-container-${productId}`
  );
  const productPriceContainer = document.querySelector(
    `.product-card-price-inner-${productId}`
  );
  const productBadgesContainer = document.querySelector(
    `.product-card-badges-${productId}`
  );
  const productTitleContainer = document.querySelector(
    `.product-card-title-text-${productId}`
  );
  const priceTemplate = document.querySelector(
    `template[data-swatch-price-template="${relatedProductId}"]`
  );
  const badgesTemplate = document.querySelector(
    `template[data-swatch-badges-template="${relatedProductId}"]`
  );

  const totalNumberOfSlides = productImagesSource.length;
  const imageWidth =
    productImages.length > 0 ? productImages[0].getBoundingClientRect().width : 0;
  const slidesContainerWidth = totalNumberOfSlides * imageWidth + "px";

  setActiveSwatch(e);

  const updatedProductImages = productImagesSource
    .map(
      (image) =>
        ` <image-with-placeholder class="relative" style="width: ${imageWidth}px ; margin-right: 0px;">
            <img src="${image}" alt="${productTitle || ""}" srcset="${image}" width="3000" height="4500" loading="lazy" class="peer/image product-image-${productId} is-complete" sizes="(min-width: 1024px) calc(100vw / 12 * 4), 50vw">
            <div class="absolute inset-0 h-full w-full bg-scheme-text opacity-[0.05] peer-[.is-complete]/image:opacity-0 no-js:hidden"></div>
          </image-with-placeholder>
        `
    )
    .join("");

  const bullets = productImagesSource
    .map(
      (_, index) =>
        `<button class="glide__bullet" data-glide-dir="=${index}"></button>`
    )
    .join("");

  if (bulletContainer) {
    bulletContainer.innerHTML = bullets;
  }

  if (productImagesContainer) {
    productImagesContainer.innerHTML = updatedProductImages;
    productImagesContainer.style.width = slidesContainerWidth;
  }

  productColorLabel.forEach((label) => {
    label.innerHTML = productColor;
  });

  if (productTitleContainer && productTitle) {
    productTitleContainer.textContent = productTitle;
  }

  const updatedSizes = productSizes
    .map((size) => {
      const isAvailable =
        size.available === "true" ? "" : "size-variant_unavailable";
      return `
            <div class="px-1 size-variant_b-plan relative ${isAvailable}">
            <p>${size.size}</p>
            </div>
        `;
    })
    .join("");

  if (productSizeChart) {
    productSizeChart.innerHTML = updatedSizes;
  }

  productAnchors.map((productAnchor) => (productAnchor.href = productUrl));

  if (productPriceContainer && priceTemplate) {
    productPriceContainer.innerHTML = priceTemplate.innerHTML.trim();
  }

  if (productBadgesContainer && badgesTemplate) {
    productBadgesContainer.innerHTML = badgesTemplate.innerHTML.trim();
  }

  if (glideInstances[productId]) {
    glideInstances[productId].destroy();
  }

  const glide = new Glide(`.product-card-slider-${productId}`, {
    type: "slider",
    perView: 1,
    gap: 0,
  });

  glide.mount();

  glideInstances[productId] = glide;
};

const onProductDetailSwatchClick = (e) => {
  setActiveSwatch(e);
  const productUrl = e.getAttribute("data-swatch-product-url");
  if (productUrl) {
    window.location.href = productUrl;
  } else {
    console.error("Product URL not found!");
  }
};

const enableSlider = () => {
  if (document.querySelectorAll(`.product-card-slider`)) {
    document.querySelectorAll(".preloader_glide").forEach((loader) => {
      loader.classList.add("hidden");
    });
    document.querySelectorAll(".product-card-slider").forEach((slider) => {
      slider.classList.remove("hidden");
      const id = slider.getAttribute("data-product-id");

      const glide = new Glide(slider, {
        type: "slider",
        perView: 1,
        gap: 0,
      });

      glide.mount();

      glideInstances[id] = glide;
    });
  }
};

const filtersWrapper = document.querySelector(".filters-wrapper");

console.log(filtersWrapper);

const observer = new MutationObserver(function () {
  enableSlider();
});

const config = {
  childList: false,
  subtree: false,
  attributes: true,
};

if (filtersWrapper) {
  observer.observe(filtersWrapper, config);
}

enableSlider();